/**
 * Entry for the standalone branding script bundle.
 * Prefer this path for DOM/API helpers; the main barrel also exports Angular BrandingService.
 */
export { getBrandingByName, getBrandingByToken } from './branding-client';
export {
  applyBrandingFavicon,
  applyBrandingStylesheet,
  extractBrandingLogoHref,
  resolveBrandingAssetUrl,
  resolveBrandingStylesheetUrl,
} from './branding-dom.utils';
export {
  buildBrandingSetFromResponse,
  getContextPath,
  setBrandingOnWindow,
  updateBrandingCssVars,
} from './helpers';
export {
  resolveBrandingSetFromUrl,
  type ResolveBrandingFromUrlOptions,
  type ResolvedBrandingFromUrl,
} from './resolve-branding-from-url';
